// Router-Basis je Plattform. Unter /admin/ bzw. /ai/ ist das Präfix die Basis; auf eigener Domain
// (ADMIN_HOST, AI_HOST) liegt die Plattform an der Wurzel und die Basis ist leer.
export function detectBasename(
  prefix: '' | '/admin' | '/ai',
  pathname = window.location.pathname,
): string {
  if (!prefix) return '';
  return pathname === prefix || pathname.startsWith(`${prefix}/`) ? prefix : '';
}
